// Tiny constellation - connected dots
export function ConstellationLine({
  color = 'rgba(255, 226, 188, 0.4)',
  className = ''
}) {
  return (
    <svg
      width="50"
      height="30"
      viewBox="0 0 50 30"
      fill="none"
      className={className}
    >
      {/* Connecting lines */}
      <path
        d="M 5 15 L 18 8 L 30 18 L 45 12"
        stroke={color}
        strokeWidth="0.5"
        fill="none"
      />
      {/* Small dots at connection points */}
      <circle cx="5" cy="15" r="1" fill={color} />
      <circle cx="18" cy="8" r="1" fill={color} />
      <circle cx="30" cy="18" r="1" fill={color} />
      <circle cx="45" cy="12" r="1" fill={color} />
    </svg>
  );
}
